import { Component } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ui-all-articles',
  templateUrl: './ui-all-articles.component.html',
  styleUrls: ['./ui-all-articles.component.scss'],
})
export class UiAllArticlesComponent {
  model!: NgbDateStruct;
  modelTo!: NgbDateStruct;

  typeSelect!: number;
  peopleSelect!: number;

  types = [
    { id: 1, name: 'Restaurant' },
    { id: 2, name: 'Cafe' },
    { id: 3, name: 'Other' },
  ];

  peoples = [
    { id: 1, name: 'People 1' },
    { id: 2, name: 'People 2' },
    { id: 3, name: 'People 3' },
  ];

  page = 2;
}
